import { IconToggleHeartOff24 } from '@cian/ui-kit-design-tokens/icons';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectPageType } from '../../../selectors/page';
import { IMobileNavigationItem } from '../../../types/mobileBottomNavigation';
import { IApplicationState } from '../../../types/redux';
import { useApplicationContext } from '../../../utils/applicationContext';
import { trackNavigationItemClick } from '../tracking';

export const useFavoritesNavigationItem = (): IMobileNavigationItem => {
  const {
    custom: { subdomain },
  } = useApplicationContext();

  const favoritesLink = useSelector<IApplicationState, string>(
    state =>
      state.servicesLinks.favorites || /* istanbul ignore next */ `https://${subdomain}.cian.ru/rent/flat/favorites/`,
  );

  const page = useSelector(selectPageType);

  const handleClick = useCallback(() => {
    trackNavigationItemClick('favorites');
  }, []);

  return {
    title: 'Избранное',
    link: favoritesLink,
    icon: IconToggleHeartOff24,
    isActive: page === 'favorites',
    onClick: handleClick,
  };
};
